<template>
    <div class="IntroduceWrap">
        <div class="SwiperWrap">
            <i class="LeftShadow"><img src="../../assets/Home/LeftShadow.png"></i>
            <swiper class="SwiperList" ref="mySwiper" :options="swiperOptions">
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img6.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/js-1.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/js-2.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/js-3.jpg"></swiper-slide>
                <div class="swiper-pagination flex" slot="pagination"></div>
            </swiper>
            <i class="RightShadow"><img src="../../assets/Home/RightShadow.png"></i>
        </div>
        <div class="CaseWrap">
            <div class="CaseTitle">
                <p>GOEASY <span>CASE</span></p>
            </div>
            <div class="ListWrap flexa">
                <div  @click="OpenUrl('http://www.craftschina.cn/')"><img src="../../assets/Home/list7.jpg"></div>
                <div  @click="OpenUrl('http://www.guchengac.com/')"><img src="../../assets/Home/list8.jpg"></div>
                <div  @click="OpenUrl('http://www.91ghd.com/')"><img src="../../assets/Home/list21.jpg"></div>
                <div><img src="../../assets/Home/list22.jpg"></div>
                <div><img src="../../assets/Home/list9.jpg"></div>
            </div>
        </div>
        <div class="GoeasyCustomWrap">
        <div class="CustomTitle">
            <p>GOEASY <span>SUPERIORITY</span></p>
        </div>
        <div class="CustomContentWrap flexa">
            <div class="flex" :class="{'Active':Flag==='1'}" @click="Tab('1')">模式</div>
            <div class="flex" :class="{'Active':Flag==='2'}" @click="Tab('2')">框架</div>
            <div class="flex" :class="{'Active':Flag==='3'}" @click="Tab('3')">技术</div>
            <div class="flex" :class="{'Active':Flag==='4'}" @click="Tab('4')">资源</div>
        </div>
        <div class="TabWraps Tab1">
            <img v-if="Flag==='1'" src="../../assets/Home/j_1.jpg">
            <img v-if="Flag==='2'" src="../../assets/Home/j_2.jpg">
            <img v-if="Flag==='3'" src="../../assets/Home/j_3.jpg">
            <img v-if="Flag==='4'" src="../../assets/Home/j_4.jpg">
        </div>
    </div>
    </div>
</template>
<script>
  export default {
    name: 'introduce',
    components: {},
    data() {
      return {
        Flag: '1',
        swiperOptions: {
          slidesPerView: 1.13,
          centeredSlides: true,
          spaceBetween: 15,
          initialSlide: 1,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination'
          }
        }
      };
    },
    methods: {
      OpenUrl(url) {
        window.open(url, '_blank');
      },
      Tab(tab) {
        this.Flag = tab;
      }
    }
  };
</script>
<style scoped lang="scss">
    @import '../../../public/Value';
    .IntroduceWrap{
        width: 100%;
        .ListWrap{
            width: 100%;
            margin: 0.05rem auto 0;
            div{
                width: 0.62rem;
                height:0.62rem;
                margin-right: 0.05rem;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            div:last-child{
                margin-right: 0;
            }
        }
        .SwiperWrap {
            width: 100%;
            height: 1.3rem;
            position: relative;
            overflow: hidden;
            .swiper-pagination {
                width: 100%;
                height: 0.1rem;
                position: absolute;
                bottom: 0.02rem;
                ::v-deep .swiper-pagination-bullet-active {
                    background-color: #fff !important;
                }
                ::v-deep .swiper-pagination-bullet {
                    width: 0.15rem;
                    height: 0.02rem;
                    opacity: 1;
                    margin: 0 0.02rem;
                    background-color: #4d4d4d;
                    border-radius: 0.03rem;
                }
            }

            .LeftShadow, .RightShadow {
                height: 100%;
                position: absolute;
                z-index: 2;

                img {
                    height: 100%;
                    transform: scale(1.1);
                }
            }

            .LeftShadow {
                left: -0.1rem;
                top: 0;
            }

            .RightShadow {
                right: -0.1rem;
                top: 0;
            }

            .SwiperList {
                width: 100%;
                height: 100%;

                .ImgWrap {
                    border-radius: 0.1rem;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 0.1rem;
                    }
                }
            }
        }
        .TabWraps{
            width: 100%;
            margin: 0 auto;
            img{
                width: 100%;
            }
        }
        .GoeasyCustomWrap{
            width: 88%;
            margin: 0.2rem auto 0;
            .CustomContentWrap{
                width: 100%;
                margin-top: 0.1rem;
                div{
                    width: 0.5rem;
                    height: 0.15rem;
                    border-radius: 0.3rem;
                    font-size: $AdditionTextSize;
                    color:#fff;
                    background-color: #0099cc;
                    margin-left: 0.44rem;
                    cursor: pointer;
                }
                div:first-child{
                    margin-left: 0;
                }
                div.Active{
                    background-color: #ff3333;
                }
            }
            .CustomTitle{
                width: 100%;
                border-bottom: 2px solid #fff;
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .CaseWrap{
            width: 88%;
            margin: 0.2rem auto 0;
            .zz{
                width: 100%;
                margin: 0.2rem 0;
                img{
                    width: 100%;
                }
            }
            .CaseTitle{
                width: 100%;
                border-bottom: 2px solid #fff;
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.04rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
    }
</style>
